import React from "react";
import { Image } from "react-native";

interface Props { size?: number }

export default function MoreVerticalIcon({ size = 24 }: Props) {
  return <Image source={require("../../assets/icons/more-vertical.png")} style={{ width: size, height: size }} resizeMode="contain" />;
}
